import {
  createEvent,
  createStore,
  restore,
  sample,
  createEffect,
} from 'effector'

import { fx } from '../../libs'
import { User, UserRole } from './types'
import { logout } from '../auth/events'

export const userProfileMounted = createEvent()
export const setUserProfile = createEvent<User>()
export const setUserRole = createEvent<UserRole>()

export const $userProfile = restore(setUserProfile, {
  id: '',
  email: '',
  firstName: '',
  lastName: '',
  avatarURL: '',
  permissions: [],
  roles: [],
})

export const getUser = fx<void, User>({
  method: 'GET',
  url: '/profile',
})

export const $userRole = createStore<UserRole | null>(null)
$userRole.on(setUserRole, (_, roles) => roles)
// when component is mounted check user

$userProfile.reset(logout)
$userRole.reset(logout)

// Новый эффект для инициализации профиля с кэшем
export const initUserProfileFx = createEffect(
  async ({ force = false }: { force?: boolean } = {}) => {
    const key = 'profile'
    if (!force) {
      const cache = localStorage.getItem(key)
      if (cache) {
        try {
          const { data, ts } = JSON.parse(cache)
          if (typeof ts === 'number' && Date.now() - ts < 15 * 60 * 1000) {
            setUserProfile(data)
            setUserRole(data.roles)
            return data
          }
        } catch { }
      }
    }
    // Если нет кэша или force — делаем запрос
    const res = await getUser({})
    if (res && res.body) {
      localStorage.setItem(
        key,
        JSON.stringify({ data: res.body, ts: Date.now() }),
      )
      setUserProfile(res.body)
      setUserRole(res.body.roles)
      return res.body
    }
    return null
  },
)

// Заменяем вызов getUser на initUserProfileFx при монтировании
sample({
  clock: userProfileMounted,
  target: initUserProfileFx,
})

// update profile model

sample({
  clock: getUser.doneData,
  fn: (doneData) => doneData.body,
  target: setUserProfile,
})
